import { AppState } from '../../../../types'
import { AdvancedAlertModalState } from './model'

const getAdvancedAlertModalState = (state: AppState): AdvancedAlertModalState => state.monitoring.advancedAlertModal

export const isAdvancedAlertModalOpened = (state: AppState) => getAdvancedAlertModalState(state).isAdvancedAlertModalOpened
